import { render, staticRenderFns } from "./questionnaireDetail.vue?vue&type=template&id=6d241270&scoped=true&"
import script from "./questionnaireDetail.vue?vue&type=script&lang=js&"
export * from "./questionnaireDetail.vue?vue&type=script&lang=js&"
import style0 from "./questionnaireDetail.vue?vue&type=style&index=0&id=6d241270&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d241270",
  null
  
)

export default component.exports